requestAnimationFrame(() => {
  scriptController.executeWhenScriptLoaded(['modal-dialog.js'], () => {
    scriptController.onStyleReady(() => {
      function throttle(func, delay) {
        let lastCall = 0;

        return function(...args) {
          const now = Date.now();
          if (now - lastCall >= delay) {
            lastCall = now;
            func.apply(this, args);
          }
        };
      }

      if (!customElements.get('cart-drawer')) {
        class CartDrawer extends ModalDialog {
          constructor() {
            super();

            if (window.addToCartAction === 'cart_drawer' && !window.location.pathname.includes('/cart')) {
              subscribe(PUB_SUB_EVENTS.cartUpdateFinish, this.show.bind(this));
            }

            this.throttledCheckFooter = throttle(this.updateFooterState.bind(this), 400);
            scriptController.scripts.push('cart-drawer.js');
          }

          show() {
            super.show(...arguments);

            if (Shopify.designMode) return;

            this.startFooterUpdates();
          }

          startFooterUpdates() {
            const update = () => {
              this.throttledCheckFooter();
              this.animationId = requestAnimationFrame(update);
            };
            this.animationId = requestAnimationFrame(update);
          }

          updateFooterState() {
            this.footer = this.querySelector('.cart-drawer__footer');
            this.itemsWrapper = this.querySelector('.cart-drawer__items');
            this.items = this.itemsWrapper.querySelectorAll('.cart-drawer-item');
            this.notesDropdown = this.footer.querySelector('.animated-dropdown__dropdown');
            let footerHeight = this.footer.offsetHeight;

            if (this.notesDropdown) {
              footerHeight -= this.notesDropdown.offsetHeight;
            }

            let itemsBottomLimit = this.itemsWrapper.offsetTop + footerHeight;

            this.items.forEach((element, index) => {
              if (index >= 2) return false;
              itemsBottomLimit = itemsBottomLimit + (index === 0 ? element.offsetHeight : element.offsetHeight / 2);
            });

            this.footer.classList[
              themeBase.windowHeight < itemsBottomLimit ? 'add' : 'remove'
            ]('cart-drawer__footer--static');
          }

          hide(callback) {
            cancelAnimationFrame(this.animationId);
            super.hide(callback);
          }
        }

        customElements.define('cart-drawer', CartDrawer);
      }

      /*
       * =====================================================================
       * SOLO: Remove the paired blade when a starter kit handle is removed.
       * =====================================================================
       *
       * Each kit + blade pair is added to the cart with a shared _pair_id
       * property (set in get-started-shaving.liquid). When a handle is removed
       * we look up its _pair_id and remove the blade that shares it.
       *
       * Two things matter for this to behave correctly:
       *   1. We keep a small snapshot of the cart (line -> handle + pairId + key),
       *      refreshed on load and after every cart change. We need this because
       *      the moment a removal is requested, we must already know what was on
       *      that line BEFORE the cart re-renders.
       *   2. We call the theme's original updateQuantity SYNCHRONOUSLY and FIRST.
       *      The theme's CartRemoveButton already called preventDefault(); if we
       *      delay the original call inside an async callback the drawer can fall
       *      back to the link href and navigate to /cart. Calling it immediately
       *      keeps the normal in-drawer behaviour.
       */
      if (document.getElementById('PopupModal-CartDrawer')) {

        const SOLO_BLADE_HANDLE = 'test-product-kit-1';

        // line index (1-based) -> { handle, pairId, key }
        let soloSnapshot = [];

        function soloRefreshSnapshot() {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              soloSnapshot = cart.items.map(function (item) {
                return {
                  handle: item.handle,
                  pairId: item.properties && item.properties['_pair_id'],
                  key: item.key
                };
              });
              return cart;
            })
            .catch(function () { return null; });
        }

        function soloRemoveBladeByKey(bladeKey) {
          if (!bladeKey) return;
          // Remove the blade directly by its known key (no extra /cart.js fetch).
          // Use the change.js sections API so the cart UI re-renders in the SAME
          // request that removes the blade — one round-trip instead of three.
          var sectionIds = [];
          try {
            if (window.cartBase && window.cartBase.getSectionsToRender) {
              sectionIds = window.cartBase.getSectionsToRender().map(function (s) { return s.id; });
            }
          } catch (err) {}

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              id: bladeKey,
              quantity: 0,
              sections: sectionIds.join(','),
              sections_url: window.location.pathname
            })
          })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            // If the theme can apply the returned sections directly, do so (fast).
            if (response && response.sections && window.cartBase && window.cartBase.updateSections) {
              try {
                window.cartBase.cartData = response;
                window.cartBase.updateSections(response);
              } catch (err) {
                if (window.cartBase.refreshCart) window.cartBase.refreshCart();
              }
            } else if (window.cartBase && window.cartBase.refreshCart) {
              window.cartBase.refreshCart();
            }
            soloRefreshSnapshot();
          })
          .catch(function (err) { console.warn('Solo: blade removal failed', err); });
        }

        // Fallback: look up the blade by pairId via a cart fetch (used only if
        // we don't already have the key in the snapshot).
        function soloRemoveBladeByPairId(pairId) {
          if (!pairId) return;
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var blade = cart.items.find(function (i) {
                return i.handle === SOLO_BLADE_HANDLE &&
                       i.properties &&
                       i.properties['_pair_id'] === pairId;
              });
              if (!blade) { soloRefreshSnapshot(); return; }
              soloRemoveBladeByKey(blade.key);
            })
            .catch(function (err) { console.warn('Solo: blade lookup failed', err); });
        }

        function soloInstallHook() {
          const original = window.cartBase.updateQuantity.bind(window.cartBase);

          window.cartBase.updateQuantity = function (opts) {
            // Only act on removals
            if (opts.quantity !== 0) {
              return original(opts);
            }

            // What is being removed? Read from the snapshot (1-based line).
            const removing = soloSnapshot[parseInt(opts.line, 10) - 1];

            // Call the theme original IMMEDIATELY (keeps normal drawer behaviour).
            const result = original(opts);

            // If a kit (handle, not blade) with a pairId was removed, remove its
            // paired blade. We already know the blade's key from the snapshot, so
            // we can remove it directly with no extra cart fetch — this is what
            // makes it feel fast. A tiny delay avoids the two writes colliding.
            if (removing && removing.handle !== SOLO_BLADE_HANDLE && removing.pairId) {
              const pairId = removing.pairId;

              // Find the paired blade's key in the snapshot we captured pre-removal
              var pairedBlade = null;
              for (var i = 0; i < soloSnapshot.length; i++) {
                var s = soloSnapshot[i];
                if (s && s.handle === SOLO_BLADE_HANDLE && s.pairId === pairId) {
                  pairedBlade = s;
                  break;
                }
              }

              setTimeout(function () {
                if (pairedBlade && pairedBlade.key) {
                  soloRemoveBladeByKey(pairedBlade.key); // fast path, no fetch
                } else {
                  soloRemoveBladeByPairId(pairId);       // fallback
                }
              }, 120);
            } else {
              setTimeout(soloRefreshSnapshot, 120);
            }

            return result;
          };
        }

        // Keep the snapshot fresh on every cart change
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          if (PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, soloRefreshSnapshot);
          if (PUB_SUB_EVENTS.cartUpdateFinish) subscribe(PUB_SUB_EVENTS.cartUpdateFinish, soloRefreshSnapshot);
          if (PUB_SUB_EVENTS.quantityUpdate) subscribe(PUB_SUB_EVENTS.quantityUpdate, soloRefreshSnapshot);
        }

        // cartBase loads from cart.js separately — poll until ready, then init
        const soloInterval = setInterval(function () {
          if (window.cartBase && window.cartBase.updateQuantity) {
            clearInterval(soloInterval);
            soloRefreshSnapshot();
            soloInstallHook();
          }
        }, 50);

        // Also refresh the snapshot whenever the drawer is opened, so it's
        // never stale by the time the user clicks remove.
        document.addEventListener('click', function (e) {
          if (e.target.closest('[href="#PopupModal-CartDrawer"], .header__icon--cart, [data-cart-drawer-toggle]')) {
            soloRefreshSnapshot();
          }
        });
      }

    }, ['component-cart-drawer']);
  });
});